/**
 * lib/views/javascripts/proto/voice/barge-in.js — what the person's first
 * words mean when they speak over the agent: "mhm" is a backchannel and is
 * ignored; "wait", "stop", the agent's name, or anything substantive is a
 * stop.
 *
 * The patterns are lib/proto/voice/interrupt.js's (the single source), sent
 * as boot data; this module only applies them.
 *
 * Contents: view
 * Ontology: Code object M33C-1019 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

// ── Classifier ───────────────────────────────────────────────────────────
// → 'backchannel' | 'stop' | 'unknown'
export function classifier(backchannelRxSrc, stopRxSrc) {
  const BACKCHANNEL_RX = new RegExp(backchannelRxSrc, 'i');
  const STOP_RX = new RegExp(stopRxSrc, 'i');
  return function classify(text) {
    if (!text) return 'unknown';
    const t = String(text).trim();
    if (!t) return 'unknown';
    if (BACKCHANNEL_RX.test(t)) return 'backchannel';
    if (STOP_RX.test(t)) return 'stop';
    const words = t.split(/\s+/).filter(Boolean);
    if (words.length >= 3 || t.length >= 15) return 'stop';
    return 'unknown';
  };
}
